// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number, string, any } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdPresetBannerTemplatesIdResult = objectOf({
  id: string,
  name: string,
  description: string,
  html: string,
  last_edited_at: number,
  template_id: string,
  grapes_js_data: any,
});
